import React from 'react';
import { Button, Typography } from 'antd';
import PropTypes from 'prop-types';

const SectorTitleButton = ({ buttonText, icon,isActive,height,handleClick,backgroundColor,textColor,fontSize }) => {
  const buttonStyle = {
    width: '100%',
    height: height??'60px',
    //flexShrink: 0,
    
    backgroundColor: backgroundColor??'#008D6B',
    //filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25)) drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin:'10px',
    borderRadius: '15px'
  };
  const { Title } = Typography;

  return (
    <Button style={buttonStyle}  onClick={handleClick} disabled={!isActive??true}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',  }}>
       {icon}
       
          <Title level={4} style={{fontSize:fontSize??'18px', marginLeft:'10px' ,color: textColor??'#FFF', fontStyle: 'normal', fontWeight: '700',textAlign:'center',marginTop:'5px' }}>
            {buttonText}
          </Title>
        
      </div>
    </Button>
  );
};

SectorTitleButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  icon: PropTypes.element,
  isActive: PropTypes.bool,
  height:PropTypes.string,
  handleClick: PropTypes.func
};

export default SectorTitleButton;
